import { InhouseTicketSystemType } from '@api';
import { z } from 'zod';

const venueInhouseTicketSystemFormSchema = z.object({
  ticketSystem: z.string(),
  notes: z.string(),
});

type VenueInhouseTicketSystemFormSchemaType = typeof venueInhouseTicketSystemFormSchema;
export type VenueInhouseTicketSystemFormDataType = z.infer<VenueInhouseTicketSystemFormSchemaType>;

type UseVenueInhouseTicketSystemFormSchemaReturnType = {
  schema: VenueInhouseTicketSystemFormSchemaType;
  defaultValues: VenueInhouseTicketSystemFormDataType;
};

export const useVenueInhouseTicketSystemFormSchema = (
  venueInhouseTicketSystem: InhouseTicketSystemType
): UseVenueInhouseTicketSystemFormSchemaReturnType => {
  const defaultValues: VenueInhouseTicketSystemFormDataType = {
    ticketSystem: venueInhouseTicketSystem.ticketSystem ?? '',
    notes: venueInhouseTicketSystem.notes ?? '',
  };

  return { schema: venueInhouseTicketSystemFormSchema, defaultValues };
};
